var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "header",
    { staticClass: "layout-head" },
    [
      _c("div", { staticClass: "layout_header_top def-w f-b-c fc99" }, [
        _c("div", { staticClass: "top-left f-b-c" }, [
          _c("span", [_vm._v(_vm._s(_vm.site.name) + "欢迎您！")]),
        ]),
        _c("div", { staticClass: "top-right" }, [
          _vm._v(" 咨询电话："),
          _c("span", { staticClass: "fc33" }, [
            _vm._v(_vm._s(_vm.site.consultHotline)),
          ]),
          _vm._v(" （工作时间：" + _vm._s(_vm.site.workTime) + "） "),
        ]),
      ]),
      _c("div", { staticClass: "layout_head_container" }, [
        _c(
          "div",
          { staticClass: "def-w f-b-c" },
          [
            _c("a", { attrs: { href: "/", title: _vm.site.name } }, [
              _c("img", { attrs: { src: _vm.site.logo, alt: _vm.site.name } }),
            ]),
            _c("head-search"),
          ],
          1
        ),
      ]),
      !_vm.$route.meta.hideNav ? _c("head-nav") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }